import { useState } from "react";
import Toast from "react-bootstrap/Toast";
import { useTranslation } from "react-i18next";

function ToastNotification(props: any): JSX.Element {
  const { notification } = props;
  const { t } = useTranslation();

  const [show, setShow] = useState(notification.show);
  function toggleShow() {
    setShow(false);
  }

  function backgroundColor(notificationType: any) {
    switch (notificationType) {
      case "toast-success":
        return "bg-success";
      case "toast-error":
        return "bg-danger";
      case "toast-info":
        return "bg-info";
      case "toast-warning":
        return "bg-warning";

      default:
        return "";
    }
  }

  return (
    <Toast
      show={show}
      onClose={toggleShow}
      delay={5000}
      autohide
      id="toast-detail"
      style={{
        position: "absolute",
        top: "10px",
        right: "15px",
        zIndex: "1112",
        boxShadow: "5px",
      }}
      className={`toast uni-toast  ${notification.type}`}
    >
      <div className={`toast-header ${backgroundColor(notification.type)}`}>
        {/* {-renderIcon(notification.type)} */}
        <strong className="mr-auto text-white">
          {t(notification.shortText)}
        </strong>
        <div
          onClick={toggleShow}
          className="close"
          data-dismiss="toast"
          aria-label="Close"
        >
          <i className="bi bi-x-lg"></i>
        </div>
      </div>
      <div className="toast-body">{t(notification.longText)}</div>
    </Toast>
  );
}
export default ToastNotification;
